import React from 'react';
import classNames from 'classnames';

import { SubNavItem as SubNavItemType } from '../types';

import NavItemElement from './nav-element';
import NavBadges from './nav-badges';

import history from '../../../../../shared/history';
import { getNavItemIcon } from '../utils/get-nav-item-icon';

type SubNavItemProps = {
  item: SubNavItemType;
  index: number;
  isSubNavOpen: boolean;
  isExpanded: boolean;
  shouldShowSidebarInfo?: boolean;
  showInfoOnDemo?: boolean;
  count?: number;
  hasVisitedAgencyPortal?: boolean;
  missedCallCount?: number;
};

const SubNavItem: React.FC<SubNavItemProps> = ({
  item,
  index,
  shouldShowSidebarInfo,
  showInfoOnDemo,
  count,
  hasVisitedAgencyPortal,
  missedCallCount,
}) => {
  const subNavItemClassNames = (obj) =>
    classNames([
      'app-sidebar__nav-item',
      {
        active:
          obj.route !== '' &&
          (obj.sameRouteAsParent
            ? history?.location?.pathname === obj.route
            : history?.location?.pathname?.startsWith(obj.route)),
        celloClass: obj.key === 'referral',
      },
    ]);

  return (
    <div
      key={item.key}
      className="app-sidebar__sub-nav-item"
      style={{
        transitionDelay: `${index * 30}ms`, // Convert 0.03s to 30ms
      }}
    >
      <NavItemElement
        itemRoute={item.route}
        className={subNavItemClassNames(item)}
      >
        <div className="nav-item-left">
          <div className="nav-item-icon">{getNavItemIcon(item.key)}</div>

          <span className="nav-item-text">{item.text}</span>
        </div>
        <div className="nav-item-right">
          <NavBadges
            type="expanded"
            itemKey={item.key}
            shouldShowSidebarInfo={shouldShowSidebarInfo}
            showInfoOnDemo={showInfoOnDemo}
            count={count}
            hasVisitedAgencyPortal={hasVisitedAgencyPortal}
            missedCallCount={missedCallCount}
          />
        </div>
      </NavItemElement>
    </div>
  );
};

export default SubNavItem;
